




















































import { computed, defineComponent, PropType } from "@vue/composition-api";
import { isAudioFile, isImageFile, isMediaFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getMediaDuration } from "@/lib/time";
import { PostFileData } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import FileImageView from "./components/FileImageView";
import MediaImageView from "./components/MediaImageView";
import PublicAccessToggle from "../PublicAccessToggle";

export default defineComponent({
  name: "PostFilePreview",
  components: {
    BaseIcon,
    PublicAccessToggle,
    BaseIconButton,
    MediaImageView,
    LoadingThumbnail,
    FileImageView,
  },
  props: {
    postFile: { type: Object as PropType<PostFileData>, required: true },
    showPublicAccessToggle: { type: Boolean, default: false },
    hideCloser: { type: Boolean, default: false },
    forceHideToggle: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
  },
  setup(props) {
    const processingError = computed(() => props.postFile.processingStatus === "ERROR");
    const isPublic = computed(() => !props.showPublicAccessToggle || props.postFile.public);
    const icon = computed(() => {
      if (isVideoFile(props.postFile)) return "sci-video";
      if (isImageFile(props.postFile)) return "sci-image";
      if (isAudioFile(props.postFile)) return "sci-music-note-fill";
      return "sci-file-outline";
    });
    const src = computed(() => {
      if (!props.postFile.url) return "";
      if (isVideoFile(props.postFile)) return MediaFilesController.getVideoThumbnail(props.postFile.url, "480p");
      if (isImageFile(props.postFile)) return MediaFilesController.getImageThumbnail(props.postFile.url, "480p");
      return "";
    });
    const duration = computed(() => {
      if (props.postFile.duration) return getMediaDuration(props.postFile.duration);
      return "";
    });
    const isMedia = computed(() => isMediaFile(props.postFile));

    return { processingError, isPublic, icon, src, duration, isMedia };
  },
});
